// extracted by mini-css-extract-plugin
export var chevron = "_da-4";
export var chevronExpanded = "_da-5";
export var row = "_da-0";
export var rowBody = "_da-6";
export var rowDescription = "_da-7";
export var rowHeader = "_da-1";
export var rowTitle = "_da-2";
export var rowTitleComplete = "_da-3";